export const GET_PLANS_COVERAGE = 'GET_PLANS_COVERAGE';
export const GET_PLANS_COVERAGE_LOADING = 'GET_PLANS_COVERAGE_LOADING';
export const GET_PLANS_COVERAGE_ERROR = 'GET_PLANS_COVERAGE_ERROR';

export const GET_PLANS_COVERAGE_FILTER = 'GET_PLANS_COVERAGE_FILTER';
export const GET_PLANS_COVERAGE_FILTER_LOADING = 'GET_PLANS_COVERAGE_FILTER_LOADING';
export const GET_PLANS_COVERAGE_FILTER_ERROR = 'GET_PLANS_COVERAGE_FILTER_ERROR';

export const GET_PLANS_COVERAGE_BY_ID = 'GET_PLANS_COVERAGE_BY_ID';
export const GET_PLANS_COVERAGE_BY_ID_LOADING = 'GET_PLANS_COVERAGE_BY_ID_LOADING';
export const GET_PLANS_COVERAGE_BY_ID_ERROR = 'GET_PLANS_COVERAGE_BY_ID_ERROR';

export const CREATE_PLAN_COVERAGE = 'CREATE_PLAN_COVERAGE';
export const CREATE_PLAN_COVERAGE_LOADING = 'CREATE_PLAN_COVERAGE_LOADING';
export const CREATE_PLAN_COVERAGE_ERROR = 'CREATE_PLAN_COVERAGE_ERROR';
export const CREATE_PLAN_COVERAGE_RESET_STATE = 'CREATE_PLAN_COVERAGE_RESET_STATE';

export const UPDATE_PLAN_COVERAGE = 'UPDATE_PLAN_COVERAGE';
export const UPDATE_PLAN_COVERAGE_LOADING = 'UPDATE_PLAN_COVERAGE_LOADING';
export const UPDATE_PLAN_COVERAGE_ERROR = 'UPDATE_PLAN_COVERAGE_ERROR';
export const UPDATE_PLAN_COVERAGE_RESET_STATE = 'UPDATE_PLAN_COVERAGE_RESET_STATE';

export const UPDATE_COVERAGES = 'UPDATE_COVERAGES';
export const UPDATE_COVERAGES_LOADING = 'UPDATE_COVERAGES_LOADING';
export const UPDATE_COVERAGES_ERROR = 'UPDATE_COVERAGES_ERROR';
export const UPDATE_COVERAGES_RESET_STATE = 'UPDATE_COVERAGES_RESET_STATE';

export const DELETE_PLAN_COVERAGE = 'DELETE_PLAN_COVERAGE';
export const DELETE_PLAN_COVERAGE_LOADING = 'DELETE_PLAN_COVERAGE_LOADING';
export const DELETE_PLAN_COVERAGE_ERROR = 'DELETE_PLAN_COVERAGE_ERROR';
export const DELETE_PLAN_COVERAGE_RESET_STATE = 'DELETE_PLAN_COVERAGE_RESET_STATE';

export const PLANS_COVERAGE_RESET_STATE = 'PLANS_COVERAGE_RESET_STATE';
